import {
  showFinishCardContentAndSection,
} from './case_experience_in_rails';
import { hideRailsuiModal, showRailsuiModal } from '../railsui_modal';
import { caseViewerDocumentId, createModalPendingStorage } from './modal_pending_storage';

const LOW_TIME_MODAL_ID = 'low-time-new-modal';
const CASE_COMPLETION_MODAL_ID = 'case-completion-modal';
const LEGACY_LOW_TIME_MODAL_KEY = 'lowTimeModal';
const STORAGE_KEY_PREFIX = 'case-experience:lowTimeModalPending:';

/** Sync claim so concurrent Finish Case connects restore at most once per document. */
const restoreClaims = new Set();

const lowTimeModalPending = createModalPendingStorage(STORAGE_KEY_PREFIX, {
  legacyKeys: [LEGACY_LOW_TIME_MODAL_KEY],
});

export { caseViewerDocumentId };

export function lowTimeModalRoot() {
  return document.getElementById(LOW_TIME_MODAL_ID);
}

export async function showLowTimeCaseModal() {
  return showRailsuiModal(lowTimeModalRoot(), { disableEscape: true });
}

export function hideLowTimeCaseModal() {
  hideRailsuiModal(lowTimeModalRoot());
}

/** Namespaced per document so concurrent cases do not collide. */
export const lowTimeModalPendingStorageKey = lowTimeModalPending.storageKey;

export const isLowTimeModalPending = lowTimeModalPending.isPending;

/**
 * Client-only UI flag so low-time modal survives refresh.
 * Not shared across devices/sessions — set true before open, remove on complete/reset.
 */
export const persistLowTimeModalPending = lowTimeModalPending.persist;

/** Reopen via Aquifer UI modal lifecycle when localStorage still has pending=true. */
export async function restoreLowTimeModalIfPending(showFn = showLowTimeCaseModal) {
  const documentId = caseViewerDocumentId();
  if (documentId == null || !isLowTimeModalPending(documentId)) return false;
  if (restoreClaims.has(documentId)) return false;
  restoreClaims.add(documentId);

  hideRailsuiModal(document.getElementById(CASE_COMPLETION_MODAL_ID));
  const opened = await showFn();
  if (!opened) {
    persistLowTimeModalPending(false, documentId);
    restoreClaims.delete(documentId);
    await showFinishCardContentAndSection();
  }
  return opened;
}

/** Test-only: clear in-page restore claims between examples. */
export function resetLowTimeModalRestoreClaimsForTests() {
  restoreClaims.clear();
}
